__webpack_require__.p = "/movie-hanz/";